export const LOCAL_STORAGE_QUERY_PARAMS = 'query-params';
export const SEARCH_QUERY_ORIGIN_PARAM = 'ps';
export const SEARCH_QUERY_DEFAULT_PARAM = 's';
export const PRODUCT_PARAMS = 'pp';
export const FAKE_BASE_URL = 'http://a';
